// Section 16: the norm registry. NormId is derived from config.norms.
import type { Config } from '../../config';
import { checkRegistryKeys, type NormDef } from '../../core/registry';
import type { NormId } from '../../core/types';
import { childrenFirst } from './children-first';
import { eldersLast } from './elders-last';
import { equalShares } from './equal-shares';
import { foundersFirst } from './founders-first';
import { harshJustice } from './harsh-justice';
import { mercifulJustice } from './merciful-justice';
import { workersFirst } from './workers-first';

/** Build the norms registry for a config (content numbers come from the config, ADR-0008). */
export function buildNorms(config: Config) {
  const norms = Object.freeze({
    'workers-first': workersFirst(config),
    'children-first': childrenFirst(config),
    'elders-last': eldersLast(config),
    'equal-shares': equalShares(config),
    'founders-first': foundersFirst(config),
    'harsh-justice': harshJustice(config),
    'merciful-justice': mercifulJustice(config),
  } satisfies Record<NormId, NormDef>);
  checkRegistryKeys('norms', norms);
  return norms;
}
